import * as types from "./constant"
const initialState = {
  errors: "",
  loading: false,
  staffData: [],
  dailyAttendance: [],
  TodaysLecture: [],
}

const TeacherDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_STAFF_START:
      return {
        ...state,
        loading: true,
      }
    case types.GET_STAFF_SUCCESS:
      return {
        ...state,
        loading: false,
        staffData: action.payload,
      }
    case types.GET_STAFF_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      }
    // STAFF ATTENDANCE
    case types.GET_STAFF_ATTENDANCE_START:
      return {
        ...state,
        loading: true,
      }
    case types.GET_STAFF_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyAttendance: action.payload,
      }
    case types.GET_STAFF_ATTENDANCE_FAILED:
      return {
        ...state,
        loading: false,
        dailyAttendance: [],
      }

    // TODAYS LECTURE

    case types.GET_TIMETABLE_DAYS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case types.GET_TIMETABLE_DAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        TodaysLecture: action.payload,
      }
    case types.GET_TIMETABLE_DAYS_FAIL:
      return {
        ...state,
        loading: false,
        TodaysLecture: [],
      }
    default:
      return state
  }
}

export default TeacherDashboardReducer
